import axios from '@/libs/api.request'

export const GetAgentNotice = params => {
  return axios.request({
    url: '/print/notice',
    params,
    method: 'get'
  })
}
export const SaveAgentNotice = data => {
  return axios.request({
    url: '/print/notice',
    data,
    method: 'post'
  })
}
export const DelNotice = data => {
  return axios.request({
    url: '/print/notice/del',
    data,
    method: 'post'
  })
}
